import { useState } from 'react'

import Dialog from '@mui/material/Dialog'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'

import { ProductActief } from '../../project/components/dialogs/ProductActief'
import type { Produkt } from '../../project/types/Produkt'
import type { Project } from '../../project/types/Project'

import { Discipline } from './Discipline'

const findByDisciplineNetbeheerder = (
  produkten,
  disciplineCode,
  netbeheerderCode,
) =>
  produkten &&
  produkten.find(
    (p) =>
      p.disciplineCode === disciplineCode &&
      p.netbeheerderCode === netbeheerderCode,
  )
const disciplineFilter = (disciplineCode, netbeheerderCode) => (object) =>
  findByDisciplineNetbeheerder(
    object.produkten,
    disciplineCode,
    netbeheerderCode,
  ) !== undefined

interface Props {
  project: Project
  product: Partial<Produkt>
  objectFilter?: any
}

export const Disciplines = ({
  project,
  product: { disciplineCode, netbeheerderCode },
  objectFilter,
}: Props) => {
  const [disciplineID, setDisciplineID] = useState('')
  const objecten = objectFilter
    ? project.aansluitObjecten.filter(objectFilter)
    : project.aansluitObjecten

  const handleDeactivate = (disciplineID: string) => {
    setDisciplineID(disciplineID)
  }

  return objecten ? (
    <>
      <Table>
        <TableBody>
          {objecten
            .filter(disciplineFilter(disciplineCode, netbeheerderCode))
            .map((object, index) => {
              const product = findByDisciplineNetbeheerder(
                object.produkten,
                disciplineCode,
                netbeheerderCode,
              )

              return (
                <Discipline
                  key={object.objectID}
                  project={project}
                  object={object}
                  product={product}
                  expanded={index === 0}
                  onDeactivate={handleDeactivate}
                />
              )
            })}
        </TableBody>
      </Table>
      {!!disciplineID && (
        <Dialog open={true} maxWidth="md" fullWidth>
          <ProductActief
            project={project}
            disciplineID={disciplineID as string}
            handleClose={() => setDisciplineID('')}
          />
        </Dialog>
      )}
    </>
  ) : (
    <></>
  )
}
